export enum QualificationTargetTypeModel {
  ByEmployee = 0,
  ByTrainingGroup = 1,
}
